export default function ProductAmount({ children }: { children: JSX.Element | string }) {
    return <div className="text-white">{children}</div>;
}